import { authFetch } from "../authFetch";


export const getClassByTrainer = async (requestData) => {
  try {
    const res = await authFetch(`class/filter/bytrainer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    });

    const data = await res.json();
    return data;
  } catch (err) {
    console.error(err);
  }
};
